import React from 'react';
import classNames from 'classnames';
import { applyStylingHoc } from '../../lib/styling.js';
import baseStyles from './Grid.scss';
export var Container = function Container(props) {
  var styles = props.styles,
      children = props.children,
      noGutters = props.noGutters,
      fixed = props.fixed,
      maxWidthDisabled = props.maxWidthDisabled;
  return React.createElement("div", {
    className: classNames(styles.root, fixed ? styles.container : styles.containerFluidLg, noGutters && styles['has-noGutters'], maxWidthDisabled && styles['has-noMaxWidth'])
  }, children);
};
export default applyStylingHoc(baseStyles)(Container);